
import { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import AboutPage from '../pages/about/page';
import CFNPage from '../pages/cfn/page';
import TrainingPage from '../pages/training/page';
import JoinPage from '../pages/join/page';
import NotFound from '../pages/NotFound';
import LeadershipPage from '../pages/leadership/page';
import ProgramsPage from '../pages/programs/page';
import OneFoldPage from '../pages/one-fold/page';
import EcclesiaPage from '../pages/ecclesia/page';
import ConventionPage from '../pages/convention/page';
import MissionsPage from '../pages/missions/page';
import MedicalMissionPage from '../pages/medical-mission/page';
import PublicationsPage from '../pages/publications/page';
import CrusadesPage from '../pages/crusades/page';
import RalliesPage from '../pages/rallies/page';
import EventsPage from '../pages/events/page';
import ResourcesPage from '../pages/resources/page';
import LiveStreamingPage from '../pages/live-streaming/page';
import ContactPage from '../pages/contact/page';
import PrivacyPage from '../pages/privacy/page';
import TermsPage from '../pages/terms/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/cfn',
    element: <CFNPage />,
  },
  {
    path: '/training',
    element: <TrainingPage />,
  },
  {
    path: '/join',
    element: <JoinPage />,
  },
  {
    path: '/leadership',
    element: <LeadershipPage />,
  },
  {
    path: '/programs',
    element: <ProgramsPage />,
  },
  {
    path: '/one-fold',
    element: <OneFoldPage />,
  },
  {
    path: '/ecclesia',
    element: <EcclesiaPage />,
  },
  {
    path: '/convention',
    element: <ConventionPage />,
  },
  {
    path: '/missions',
    element: <MissionsPage />,
  },
  {
    path: '/medical-mission',
    element: <MedicalMissionPage />,
  },
  {
    path: '/publications',
    element: <PublicationsPage />,
  },
  {
    path: '/crusades',
    element: <CrusadesPage />,
  },
  {
    path: '/rallies',
    element: <RalliesPage />,
  },
  {
    path: '/events',
    element: <EventsPage />,
  },
  {
    path: '/resources',
    element: <ResourcesPage />,
  },
  {
    path: '/live-streaming',
    element: <LiveStreamingPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/privacy',
    element: <PrivacyPage />,
  },
  {
    path: '/terms',
    element: <TermsPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
